module.exports = __webpack_public_path__ + "static/DSC_9237-efa753f4aa00e7832169b52a8aefbd14.jpg";